module.exports = __webpack_public_path__ + "img/bedsheet.5564d778.jpeg";